<ng-container *ngIf="engineReplacementForm$ | async as engineReplacementForm">
  <div class="d-flex justify-content-between align-items-center" *ngIf="engineReplacementForm">
    <h2 class="cx-checkout-title d-block" [class.is-service-parts]="isServicePartsEnabled">
      {{ 'checkoutProgress.engineReplacementForm.acknowledgmentToDestroy' | cxTranslate | titlecase }}
    </h2>
    <gen-offline-badge *ngIf="!isServicePartsEnabled" [internalCalculation]="internalCalculation"></gen-offline-badge>
  </div>

  <form *ngIf="engineReplacementForm" [formGroup]="engineReplacementFormGroup">
    <div class="row">
      <div class="form-group col-md-6">
        <label>
          <span class="label-content">
            {{ 'checkoutProgress.engineReplacementForm.modelNumberDestroyed' | cxTranslate }}
          </span>
          <input class="form-control" type="text"
            [placeholder]="'checkoutProgress.engineReplacementForm.modelNumberDestroyed' | cxTranslate"
            formControlName="engineModelNumber" />
          <cx-form-errors [control]="engineReplacementFormGroup.get('engineModelNumber')"></cx-form-errors>
        </label>
      </div>

      <div class="form-group col-md-6">
        <label>
          <span class="label-content required">
            {{ 'checkoutProgress.engineReplacementForm.serialNumberDestroyed' | cxTranslate }} <sup>*</sup>
          </span>
          <input class="form-control" type="text"
            [placeholder]="'checkoutProgress.engineReplacementForm.serialNumberDestroyed' | cxTranslate"
            formControlName="engineSerialNumber" />
          <cx-form-errors [control]="engineReplacementFormGroup.get('engineSerialNumber')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-6">
        <label>
          <span class="label-content required">
            {{ 'checkoutProgress.engineReplacementForm.accountId' | cxTranslate }}
          </span>
          <input class="form-control" type="text"
            [placeholder]="'checkoutProgress.engineReplacementForm.accountId' | cxTranslate"
            formControlName="dealerId" />
          <cx-form-errors [control]="engineReplacementFormGroup.get('dealerId')"></cx-form-errors>
        </label>
      </div>

      <div class="form-group col-md-6">
        <label>
          <span class="label-content required">
            {{ 'checkoutProgress.engineReplacementForm.purchasingUser' | cxTranslate }}
          </span>
          <input class="form-control" type="text"
            [placeholder]="'checkoutProgress.engineReplacementForm.purchasingUser' | cxTranslate"
            formControlName="purchasingUser" />
          <cx-form-errors [control]="engineReplacementFormGroup.get('purchasingUser')"></cx-form-errors>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-6">
        <label>
          <span class="label-content required">
            {{ 'checkoutProgress.engineReplacementForm.purchaseDate' | cxTranslate }}
          </span>
          <input class="form-control" type="text"
            [placeholder]="'checkoutProgress.engineReplacementForm.purchaseDate' | cxTranslate"
            formControlName="purchaseDate" />
          <cx-form-errors [control]="engineReplacementFormGroup.get('purchaseDate')"></cx-form-errors>
        </label>
      </div>
    </div>

    <p>{{ 'checkoutProgress.engineReplacementForm.attestationCheckboxesText' | cxTranslate }}</p>

    <div class="attestation-checkboxes-selector-wrap">
      <div class="attestation-checkbox-radio" *ngFor="let controlName of attestationCheckboxesFormControls">
        <input
          [id]="('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.' + controlName) | cxTranslate"
          class="form-check-input" role="radio" type="radio" aria-checked="true"
          [name]="('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.' + controlName) | cxTranslate"
          [value]="engineReplacementFormGroup.get('replacementReason').value"
          [checked]="engineReplacementFormGroup.get('replacementReason').value == controlName"
          (change)="changeReplacementReason(controlName)" />
        <label class="attestation-checkboxes-label form-check-label form-radio-label"
          [for]="('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.' + controlName) | cxTranslate">
          <div class="attestation-checkbox">
            {{ ('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.' + controlName) | cxTranslate }}
          </div>
        </label>
         <ul *ngIf="controlName == 'PACKAGING_OR_FIT'" class="attestation-checkboxes-options-list">
          <li *ngFor="let optionKey of packagingFitOptions">
            {{ ('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.packagingFitOptions.' + optionKey) | cxTranslate }}
            <ul *ngIf="optionKey === 'equipmentEngineInterface'" class="attestation-checkboxes-options-sublist">
              <li *ngFor="let subKey of packagingFitEquipmentEngineInterfaceSubOptions">
                {{ ('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.packagingFitOptions.' + subKey) | cxTranslate }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <p class="destroyed-by-text">{{ 'checkoutProgress.engineReplacementForm.destroyedByText' | cxTranslate }}</p>
    <cx-form-errors class="destroyed-by-form-errors" [control]="engineReplacementFormGroup.get('destructionType')"></cx-form-errors>

    <div class="destroyed-by-selector-wrap">
      <div class="destroyed-by-checkbox-radio" *ngFor="let controlName of destroyedByOptionsControls">
        <input
          class="form-check-input" type="radio" role="radio" aria-checked="true"
          [id]="('checkoutProgress.engineReplacementForm.destroyedByOptions.' + controlName) | cxTranslate"
          [name]="('checkoutProgress.engineReplacementForm.destroyedByOptions.' + controlName) | cxTranslate"
          [value]="engineReplacementFormGroup.get('destructionType').value"
          [checked]="engineReplacementFormGroup.get('destructionType').value == controlName"
          (change)="changeDestructionType(controlName)" />
        <label class="destroyed-by-checkboxes-label form-check-label form-radio-label"
          [for]="('checkoutProgress.engineReplacementForm.destroyedByOptions.' + controlName) | cxTranslate">
          <div class="attestation-checkbox">
            {{ ('checkoutProgress.engineReplacementForm.destroyedByOptions.' + controlName) | cxTranslate }}
          </div>
        </label>
      </div>
    </div>
  </form>

  <gen-checkout-control-btns [isContinueDisabled]="engineReplacementFormGroup.invalid"
    [skipPaymentTypeStep]="skipPaymentTypeStep" [isNextActionCustom]="true"
    (nextBtnClicked)="updateEngineReplacementAttestation(engineReplacementFormGroup.getRawValue())">
  </gen-checkout-control-btns>
</ng-container>